<template>
  <div class="card">
    <div class="card-body">
      <div class="mt-0" v-if="retrievedInvoice">
        <!-- Action Buttons Group -->
        <div>
          <!-- Download PDF -->
          <action-button
            color="dark"
            icon="download"
            :loading="isLoading || isDownloading"
            @click="downloadInvoicePdf"
          >
            Download As PDF
          </action-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from "../shared/ActionButton";
import {showSuccessToast} from "../../utils/notification.utils";
import {downloadInvoicePdf} from "../../utils/invoiceUtils";
import {toFilename} from "../../utils/utils";

export default {
  name: 'ViewInvoiceSidebar',
  components: {
    ActionButton
  },
  data() {
    return {
      isDownloading: false
    };
  },
  props: {
    retrievedInvoice: Object,
    permissions: Object,
    selectedTemplateId: {
      type: String,
      default: "2"
    },
    displayDisabledButtons: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    invoiceId() {
      return this.retrievedInvoice && this.retrievedInvoice.id;
    },
    currentStatus() {
      return this.retrievedInvoice && this.retrievedInvoice.invoiceStatus;
    }
  },
  methods: {
    formatInvoiceFilename(invoiceNumber, customerName, issueDate) {
      const safeName = toFilename(customerName);
      const formatDate = (date) => date.toISOString().slice(0, 10).replace(/-/g, '');

      const datePart = issueDate ? formatDate(new Date(issueDate)) : '';
      const invoicePart = invoiceNumber ? invoiceNumber.replace(/[^a-zA-Z0-9\-]/g, '') : 'INV-UNKNOWN';

      return `Invoice_${invoicePart}_${safeName}${datePart ? `_${datePart}` : ''}.pdf`;
    },
    
    async downloadInvoicePdf() {
      this.$emit('loading', true);
      const fileName = this.formatInvoiceFilename(
        this.retrievedInvoice.invoiceNumber,
        this.retrievedInvoice.customer ? this.retrievedInvoice.customer.name : 'Unknown',
        this.retrievedInvoice.date
      );
      await downloadInvoicePdf(
        this.invoiceId,
        fileName,
        this.selectedTemplateId,
        (val) => {
          this.isDownloading = val;
        }
      );
      showSuccessToast('Done');
      this.$emit('loading', false);
    }
  }
};
</script>

<style scoped>
.d-grid {
  display: grid;
}

.gap-2 {
  gap: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/invoices/ViewInvoiceSidebar.vue